import { useState } from 'react';
import * as vp from 'vopay';

import axios from 'axios';

import vopayApi from '@/services/api.config';
import { useDataFetchIndicator } from '..';

const { api } = vopayApi;

export default function useFetchInterestAccountRates() {
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  const [interestRatesRes, setInterestRatesRes] = useState<vp.InterestAccountRatesResponse>({
    ErrorMessage: '',
    Success: false,
    InterestRates: [],
    CurrentRates: {
      'short-term': '',
    },
  });

  const source = axios.CancelToken.source();

  async function fetchInterestRates(requestParams: vp.InterestAccountRequest) {
    try {
      setDataFetchingInfo(true);
      const res = await api.fetchInterestAccountRates(requestParams, source);
      setInterestRatesRes(res);
      return res;
    } finally {
      setDataFetchingInfo(false);
    }
  }

  return {
    interestRatesRes,
    fetchInterestRates,
  };
}
